export var ContextGLWrapMode;
(function (ContextGLWrapMode) {
    ContextGLWrapMode[ContextGLWrapMode["CLAMP"] = 0] = "CLAMP";
    ContextGLWrapMode[ContextGLWrapMode["REPEAT"] = 1] = "REPEAT";
})(ContextGLWrapMode || (ContextGLWrapMode = {}));



// WEBPACK FOOTER //
// ../dist/lib/base/ContextGLWrapMode.js